import Avatar from 'common/Avatar/Avatar'
import Styles from 'components/CollabItemInlineWidget/CollabItemInlineWidget.module.scss'

interface Props {
  isActive: boolean
}

export const DefaultItemSummary = ({ isActive }: Props) => (
  <>
    <Avatar label="Anonymous" size={isActive ? 20 : 24} />
    <span className={Styles.user}>Anonymous</span>&nbsp;
  </>
)
